import { Outlet } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import React from 'react';
import "./styles.css";
/**
 * @function AdvancedAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AdvancedAlertsPage
 */
export default function AdvancedAlertsPage(props) {
  return (
    <PageContainer className="advanced-alerts-page">
        <PageContentView>
            <div className="flex-container flex-vertical page-widget-wrapper">
              <CenterContentContainer>
                <ContentHeaderView text="Advanced Alerts" />

                <div className="content-wrapper">
                  <Outlet />
                </div>
              </CenterContentContainer>
            </div>
        </PageContentView>
    </PageContainer>
  )
}
